import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { ApplicationStore } from "../../../librettoEditor/store/ApplicationStore";
import { CompositionService } from "../../../librettoEditor/services/CompositionService";
import { CANVAS_ID } from "../../../librettoEditor/config/config";

const CanvasSceneScopeToggle: React.FC = observer(() => {
  const selectedVisualElement = ApplicationStore.selectedVisualElement;
  const scope = ApplicationStore.sceneEditScope;
  const isCropMode = ApplicationStore.isCropMode;

  const [pos, setPos] = useState<{ left: number; top: number } | null>(null);

  const shouldShow = (() => {
    if (!selectedVisualElement || isCropMode) return false;
    const clip: any = CompositionService.getClipById(selectedVisualElement.clipId);
    if (!clip) return false;
    const scriptClip: any = CompositionService.getScriptLayerClip();
    const scenes: any[] = scriptClip && typeof scriptClip.getScenes === "function" ? scriptClip.getScenes() : [];
    if (!Array.isArray(scenes) || scenes.length <= 1) return false;
    return CompositionService.clipSpansMultipleScenes(clip);
  })();

  useEffect(() => {
    const compute = () => {
      if (!shouldShow) {
        setPos(null);
        return;
      }
      const canvas = document.getElementById(CANVAS_ID) as HTMLCanvasElement | null;
      if (!canvas) {
        setPos(null);
        return;
      }
      const rect = canvas.getBoundingClientRect();
      setPos({ left: rect.left + rect.width / 2, top: rect.bottom + 16 });
    };

    compute();
    const onUpdate = () => compute();
    window.addEventListener("updateHandlers", onUpdate as any);
    window.addEventListener("resize", onUpdate as any);
    return () => {
      window.removeEventListener("updateHandlers", onUpdate as any);
      window.removeEventListener("resize", onUpdate as any);
    };
  }, [shouldShow, selectedVisualElement?.clipId, scope]);

  if (!shouldShow || !pos) return null;

  return (
    <div
      style={{
        position: "fixed",
        left: pos.left,
        top: pos.top,
        transform: "translateX(-50%)",
        display: "flex",
        alignItems: "center",
        gap: 10,
        zIndex: 40,
        pointerEvents: "auto",
      }}
    >
      <span style={{ fontSize: 12, color: "#6B7280" }}>Selected in</span>
      <div
        style={{
          display: "flex",
          background: "#F3F4F6",
          borderRadius: 8,
          padding: 3,
          gap: 3,
          border: "1px solid #E5E7EB",
        }}
      >
        <button
          onClick={() => ApplicationStore.setSceneEditScope("scene")}
          style={{
            padding: "6px 12px",
            border: "none",
            borderRadius: 6,
            background: scope === "scene" ? "#fff" : "transparent",
            boxShadow: scope === "scene" ? "0 1px 3px rgba(0,0,0,0.12)" : "none",
            cursor: "pointer",
            fontSize: 13,
            color: "#111827",
            whiteSpace: "nowrap",
          }}
        >
          Current scene
        </button>
        <button
          onClick={() => ApplicationStore.setSceneEditScope("all")}
          style={{
            padding: "6px 12px",
            border: "none",
            borderRadius: 6,
            background: scope === "all" ? "#fff" : "transparent",
            boxShadow: scope === "all" ? "0 1px 3px rgba(0,0,0,0.12)" : "none",
            cursor: "pointer",
            fontSize: 13,
            color: "#111827",
            whiteSpace: "nowrap",
          }}
        >
          All scenes
        </button>
      </div>
    </div>
  );
});

export default CanvasSceneScopeToggle;

